export default "__VITE_ASSET__A2hRl8KU__"